import React from 'react';
import { EdmundsCpaNoAdhesionDecorator } from 'site-modules/shared/pages/decorators/edmunds-cpa-no-adhesion';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { pageDefinitionConfiguration } from 'site-modules/inventory/pages/usurp/usurp-definition';
import { VinPreview } from 'site-modules/inventory/pages/usurp/vin-preview';
import { SRP_PAGE_NAME } from 'site-modules/shared/constants/page-names';
import { getPagePublicationState } from 'site-modules/shared/utils/inventory/srp-utils';
import { legacyPageUpdate } from 'client/actions/legacy-page';
import { getReduxModelStateFromStore } from 'client/data/luckdragon/redux/redux-model';
import { InventoryModel } from 'client/data/models/inventory';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';

export const getPageDefinitionConfig = params => ({
  name: `${SRP_PAGE_NAME}-preview`,
  category: 'car_inventory',
  seo: { robots: { noIndex: true } },
  preload: async (store, props) => {
    await pageDefinitionConfiguration.preload(store, props, {
      ...params,
      disableCriticalCss: true,
    });

    const modelState = getReduxModelStateFromStore(store);
    const pageFilters = modelState.get('searchResultsFilter', InventoryModel);
    const inventoryType = pageFilters?.inventoryType ?? [];
    const pageNameUpdateValue = `${getPagePublicationState(inventoryType)}_car_inventory_srp_preview`;
    store.dispatch(
      legacyPageUpdate({
        pageName: pageNameUpdateValue,
      })
    );

    const preloader = new ModelPreloader(store);
    preloader.resolve(`searchResultsVin["${params.vin}"]`, InventoryModel);
    return preloader.load();
  },
  component: props => <VinPreview {...props} vin={params.vin} />,
  decorator: EdmundsCpaNoAdhesionDecorator,
  options: {
    disableScrollToTop: true,
    hasVehicleContext: true,
    vehicleContextChange: true,
    adsSpaMode: true,
    disableAdRefreshOnScroll: true,
  },
});

export default params => pageDefinition(getPageDefinitionConfig(params));
